export const LESSON_CURRENCIES = ['USD', 'UAH', 'EUR'] as const;

export type LessonCurrency = (typeof LESSON_CURRENCIES)[number];

export type LessonPackage = {
  id: number;
  lessonOfferingId: number;
  quantity: number;
  discountPercent: number;
  regularPrice: number;
  savings: number;
  price: number;
  pricePerLesson: number;
  currency: string;
  status: string;
};

export type LessonOffering = {
  id: number;
  mentorId: number;
  type: string;
  title: string;
  description: string | null;
  durationMinutes: number;
  price: number;
  currency: string;
  status: string;
  packages: LessonPackage[];
};

export type LessonOfferingDraft = {
  title: string;
  durationMinutes: string;
  price: string;
  currency: LessonCurrency;
};

export type LessonPackageDraft = {
  quantity: string;
  discountPercent: string;
};
